export const MODULATOR_TEST_RESULTS_CARD_FRENCH_LOCALE = {
  title: "Tests d'installations",
};
